import { datadogRum } from '@datadog/browser-rum'

export default {
  install () {
    const { datadog, environment, initialData } = window.ecoonline ?? {}
    const { allowUsageData } = initialData ?? {}
    const { enabled, applicationId, clientToken } = datadog ?? {}
    if (
      !allowUsageData ||
      !enabled ||
      !applicationId ||
      !clientToken
    ) return

    const config = environment === 'production'
      ? {
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20
        }
      : {
          trackUserInteractions: false,
          trackResources: false,
          trackLongTasks: false,
          sessionSampleRate: 0,
          sessionReplaceSampleRate: 0
        }

    const env = window.location.host.match(/platform-\d/)?.[0] ?? environment

    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.eu',
      service: 'platform-frontend',
      env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      defaultPrivacyLevel: 'mask',
      ...config
    })
  }
}
